import classNames from 'classnames';
import { Reference, ReferenceProps } from 'common/reference/reference';
import { ReferenceTile } from 'common/reference/reference-tile';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { ReactNode } from 'react';
import { IModule } from 'redux-state/layout/types.js';

export const GenericMarkerDescription = <T,>({
  config,
  children,
  modulePath,
  dataModule,
  classes,
  subTitle,
  isDrawer,
}: IModule<T & { sponsor?: ReferenceProps, attribution?: ReferenceProps & { parentClasses?: string } } & IMapSlotClose> & {
  children: ReactNode;
  dataModule: string;
  classes?: string;
  subTitle?: string;
}) => {
  const { subtitle: _subtitle, link, onModuleClose, title, attribution } = config;

  // "View full forecast" is too bland for tracking, so use title instead to make it more specific.
  const trackingSuborigin = link?.label?.toLowerCase().startsWith("view full forecast") ? title + '_link' : undefined;

  return (
    <Tile dataModule="marker-description-gen" config={config}>
      <div className={classNames('Tile-body', classes)} data-module={dataModule}>
        <TileBodyHeaderV2
          modulePath={modulePath}
          config={{ ...config, ...{ subtitle: subTitle ?? _subtitle, title: title } }}
          onModuleClose={onModuleClose}
          isDrawer={isDrawer}
        />
        {children}
        <Reference maxHeight={1.5} {...config.sponsor} classes='u-mT-sm' />
        <LinkRef link={link ?? config.link} trackingOrigin="map_preview_panel" trackingSuborigin={trackingSuborigin} />
        <ReferenceTile attribution={attribution} classes={attribution?.parentClasses} />
      </div>
    </Tile>
  );
};
